<template>
  <div class="page-body">
    <div>
      <van-empty image="search" :description="hauce_errmsg" v-show="huace_status === 0"></van-empty>

      <div v-show="huace_status !== 0">
        <loading v-if="is_loading" />

        <div class="cart_content" v-else>
          <div class="cart_content_div">
            <div class="cart_content_top">
              <div class="cart_content_top_l back-link" @click="backNav()">
                <span>&lt;&nbsp;</span>采购篮<font>({{this.countall}})</font>
              </div>
              <div class="flex-spacer"></div>
              <div class="cart_content_top_r" @click="showConfirmDelete()">删除</div>
            </div>
            <div class="spacer"></div>

            <div class="good_list">

              <div v-if="cart_list.length === 0" class="empty-cart">
                采购篮暂无产品!
              </div>

              <div v-else class="good_list_row" v-for="item in this.cart_list" :key="item.id">
                <div class="radio-cell"><input type="checkbox" :checked="item.ifgou == 1" @click="selectItem(item)">
                </div>
                <div class="image-cell"><img @click="navGoodDetail(item.good_id)" :src="item.good_img"></div>
                <div class="info-cell">
                  <div class="text-container" @click="navGoodDetail(item.good_id)"> {{ item.good_name }}</div>
                  <div class="price" style="color:#f85205;">{{ item.good_integral }}</div>
                  <div class="quantity" style="text-align: right;"><input @focus="selectAllText($event)"
                      @input="debouncedUpdateQuantity(item, $event)" type="text" :value="item.num"
                      style="width:80px;text-align: center;"></div>
                </div>
              </div>

            </div>

            <div class="spacer" style="height:120px"></div>

            <div class="cart_content_bottom" style="display: flex;flex-direction: column;">
              <div class="cart_content_bottom_top" style="width:90%;height:60px;">
                <textarea v-model="remark" name="remark" style="width:100%;border:1px solid #eee;padding:10px;"
                  placeholder="请输入运输目的地大概地址（以便核算运费）或其他要求"></textarea>
              </div>
              <div class="cart_content_bottom_bottom" style="display: flex;flex-direction: row;">
                <div class="cart_content_bottom_l">
                  <input type="checkbox" :checked="isAllSelected" @change="selectAllItems($event)">&nbsp;
                  <div>全选</div>
                </div>
                <div class="flex-spacer"></div>
                <div class="cart_content_bottom_r">
                  <div style="flex:1;"> 总计：<span class="total-count">{{this.countgou}}件</span></div>

                  <div class="generate-link" style="width:80px;" @click="goFanganDetail()">生成链接</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import wx from "weixin-js-sdk";
  import _ from 'lodash';
  import {
    Toast,
    Dialog
  } from 'vant';
  export default {
    data() {
      return {
        //v-if为true显示，false消失
        btnFlag: false,
        huace_status: "1",
        hauce_errmsg: "",
        is_loading: true,
        cart_list: [],
        countall: 0,
        countgou: 0,
        remark: '' // 添加 remark 属性
      };
    },

    // vue的两个生命钩子，这里不多解释。
    //mounted是vue已经加载好了；destroyed是vue已经销毁了
    // window对象，所有浏览器都支持window对象。它表示浏览器窗口，监听滚动事件
    mounted: function() {

    },
    destroyed: function() {

    },
    computed: {
      isAllSelected() {
        return this.cart_list.every(item => item.ifgou == 1);
      }
    },
    methods: {
      selectAllText(event) {
        event.target.select(); // 当输入框获得焦点时，选中其中的所有文本
      },
      // 跳转详情页
      navGoodDetail(goods_id) {
        //id是画册的id
        var id = this.$route.query.id;
        this.$router.push({
          path: "/detail",
          query: {
            id: id,
            goods_id: goods_id,
          },
        });
      },
      selectAllItems(event) {
        let app = this;
        const isChecked = event.target.checked;
        const token = localStorage.getItem("token");
        let huace_id = this.$route.query.id;
        this.$http
          .get(
            api_url + `action=change_all_ifgou&token=${token}&id=${huace_id}&ifgou=${isChecked ? 1 : 0}`
          )
          .then((res) => {
            console.log(res.data);
            if (res.data.sta == '200') {
              //重新获取购物车信息
              app.getCartInfo();
            } else {
              Toast({
                message: res.data.msg || '选择失败，请重试',
                duration: 2000,
                type: 'fail'
              });
            }
          })
          .catch((error) => {
            console.error("请求失败:", error);
            Toast({
              message: '网络请求失败，请检查您的网络连接',
              duration: 2000,
              type: 'fail'
            });
          });



      },
      updateQuantity(item, event) {
        let app = this;
        const newQuantity = event.target.value.trim();
        if (newQuantity != '') {
          if (isNaN(newQuantity) || parseInt(newQuantity) <= 0) {
            Toast({
              message: '请输入有效的数量',
              duration: 2000,
              type: 'fail'
            });
            //重新获取购物车信息
            app.getCartInfo();
            return;
          }
        }
        Toast.loading({
          message: "修改中...",
          forbidClick: true,
        });


        setTimeout(() => {

          var token = localStorage.getItem("token");

          this.$http
            .get(
              api_url + `action=change_cart_num&rowid=${item.id}&token=${token}&quantity=${newQuantity}`
            )
            .then((res) => {
              console.log(res.data);
              if (res.data.sta == '200') {
                Toast({
                  message: res.data.msg || '数量更新成功',
                  duration: 2000,
                  icon: 'success'
                });
                item.num = parseInt(newQuantity);
                //重新获取购物车信息
                app.getCartInfo();
              } else {
                Toast({
                  message: res.data.msg || '数量更新失败，请重试',
                  duration: 2000,
                  type: 'fail'
                });
                //重新获取购物车信息
                app.getCartInfo();
              }
            })
            .catch((error) => {
              console.error("请求失败:", error);
              Toast({
                message: '网络请求失败，请检查您的网络连接',
                duration: 2000,
                type: 'fail'
              });
            })
            .finally(() => {
              //Toast.clear();
            });
        }, 500);
      },
      debouncedUpdateQuantity: _.debounce(function(item, event) {
        this.updateQuantity(item, event);
      }, 1000),
      getCartInfo() {
        let app = this;
        var token = localStorage.getItem("token");
        let huace_id = this.$route.query.id;
        this.$http
          .get(api_url + `action=get_cart_info&id=${huace_id}&token=${token}`)
          .then((res) => {
            console.log(res.data);
            if (res.data.sta == '200') {
              console.log("res.data.countall", res.data.countall);
              app.cart_list = res.data.data;
              app.countall = res.data.countall;
              app.countgou = res.data.countgou;
            } else {
              Toast({
                message: res.data.msg || '购物车信息获取失败，请重试',
                duration: 2000,
                type: 'fail'
              });
            }
          })
          .catch((error) => {
            console.error("请求失败:", error);
            Toast({
              message: '网络请求失败，请检查您的网络连接',
              duration: 2000,
              type: 'fail'
            });
          })
          .finally(() => {
            Toast.clear();
          });
      },

      showConfirmDelete() {
        Dialog.confirm({
          title: '确认删除',
          message: '确定要删除勾选的商品吗？',
        }).then(() => {
          // 用户确认删除，调用删除接口
          this.deleteCart();
        }).catch(() => {
          // 用户取消删除
          console.log('取消删除');
        });
      },
      deleteCart() {
        let app = this;
        Toast.loading({
          message: "加载中...",
          forbidClick: true,
        });

        setTimeout(() => {
          let huace_id = this.$route.query.id;
          var token = localStorage.getItem("token");
          this.$http
            .get(
              api_url + `action=delete_cart&id=${huace_id}&token=${token}`
            )
            .then((res) => {
              console.log(res.data);
              // 成功和失败都提示下，然后关闭弹层
              if (res.data.sta == '200') {
                Toast({
                  message: res.data.msg || '删除成功',
                  duration: 2000,
                  icon: 'success'
                });
                //重新获取购物车信息
                app.getCartInfo();
              } else {
                Toast({
                  message: res.data.msg || '删除失败，请重试',
                  duration: 2000,
                  type: 'fail'
                });
              }
            })
            .catch((error) => {
              console.error("请求失败:", error);
              Toast({
                message: '网络请求失败，请检查您的网络连接',
                duration: 2000,
                type: 'fail'
              });
            })
            .finally(() => {
              // 无论成功还是失败，都关闭加载提示
              //Toast.clear();
            });
        }, 500);
      },

      selectItem(item) {
        let app = this;
        console.log("选中的商品:", item);
        //延迟2秒
        Toast.loading({
          message: "加载中...",
          forbidClick: true,
        });

        setTimeout(() => {


          var token = localStorage.getItem("token");

          // 当前是否被选中
          let old_ifgou = item.ifgou;
          let new_ifgou = old_ifgou == 1 ? 0 : 1;

          this.$http
            .get(
              api_url + `action=change_cart_ifgou&rowid=${item.id}&token=${token}&ifgou=${new_ifgou}`
            )
            .then((res) => {
              console.log(res.data);
              // 成功和失败都提示下，然后关闭弹层
              if (res.data.sta === '200') {
                Toast({
                  message: res.data.msg || '选择成功',
                  duration: 2000,
                  icon: 'success'
                });
                // 更新本地数据
                item.ifgou = new_ifgou;
                //重新获取购物车信息
                app.getCartInfo();

              } else {
                Toast({
                  message: res.data.msg || '选择失败，请重试',
                  duration: 2000,
                  type: 'fail'
                });
              }
            })
            .catch((error) => {
              console.error("请求失败:", error);
              Toast({
                message: '网络请求失败，请检查您的网络连接',
                duration: 2000,
                type: 'fail'
              });
            })
            .finally(() => {
              // 无论成功还是失败，都关闭加载提示
              //Toast.clear();
            });
        }, 500);
      },
      backNav() {
        var id = this.$route.query.id;

        if (window.history.length <= 1) {
          this.$router.push({
            path: "/",
            query: {
              id: id,
            },
          });
          return false;
        } else {
          this.$router.back();
          return false;
        }
        //上面都没执行就说明卡在当前页不是最后一条， histroy记录数量大于1，又没有回退记录，只能返回首页，
        //如果上面都执行了 页面都跳走了，这个也就不用管了
        setTimeout(() => {
          this.$router.push({
            path: "/",
            query: {
              id: id,
            },
          });
        }, 500);
      },

      initShow: function() {
        const app = this;
        let huace_id = this.$route.query.id;

        var token = localStorage.getItem("token");
        this.$http
          .get(
            api_url +
            `action=get_cart_list&token=${token}&id=${huace_id}`
          )
          .then((res) => {

            //如果失败了
            if (res.data.sta != '200') {
              this.huace_status = 0;
              this.hauce_errmsg = res.data.msg;
              return;
            }

            //设置变量
            document.title = res.data.info.share_title;
            app.cart_list = res.data.data;
            app.is_loading = false;

          })
          .catch(function(error) {
            console.log(error);
            Toast({
              message: '网络请求失败，请检查您的网络连接',
              duration: 2000,
              type: 'fail'
            });
          });
      },
      // 跳转方案详情
      goFanganDetail() {
        let app = this;
        // 获取备注信息
        const remark = this.remark;
        //id是画册的id
        var id = this.$route.query.id;
        Toast.loading({
          message: "方案生成中...",
          forbidClick: true,
        });
        setTimeout(() => {
          var token = localStorage.getItem("token");
          this.$http
            .get(api_url + `action=add_order&token=${token}&id=${id}&remark=${remark}`)
            .then((res) => {
              console.log(res.data);
              if (res.data.sta == '200') {
                Toast({
                  message: res.data.msg || '链接生成成功',
                  duration: 2000,
                  icon: 'success'
                });
                let keynum = res.data.keynum;
                setTimeout(() => {
                  app.$router.push({
                    path: "/fangandetail",
                    query: {
                      keynum: keynum
                    },
                  });
                }, 1500);
              } else {
                Toast({
                  message: res.data.msg || '链接生成失败，请重试',
                  duration: 2000,
                  type: 'fail',
                  dangerouslyUseHTMLString: true // 注意：这可能会带来 XSS 风险
                });
              }
            })
            .catch((error) => {
              console.error("请求失败:", error);
              Toast({
                message: '网络请求失败，请检查您的网络连接',
                duration: 2000,
                type: 'fail'
              });
            })
            .finally(() => {
              //Toast.clear();
            });

        }, 500);
        return;



      },
      //微信分享
      wechatShare() {
        var app = this;
        var id = this.$route.query.id;
        var token = localStorage.getItem("token");
        //必须要url编码，如果不变吗，url的参数值里面有&拼接会被当做接口参数以及参数值，再次发送
        let url = encodeURIComponent(window.location.href);
        var pathUrl =
          api_url + `action=get_wxshare_param&id=${id}&token=${token}&url=${url}`;
        this.$http
          .request({
              url: pathUrl,
            },
            "GET"
          )
          .then((res) => {
            console.log("get_wxshare_param", res);
            if (res.data.sta == 200) {
              let data = res.data;
              //通过config接口注入权限验证配置
              wx.config({
                debug: data.res.is_debug_fx,
                appId: data.res.appId,
                timestamp: data.res.timestamp,
                nonceStr: data.res.nonceStr,
                signature: data.res.signature,
                jsApiList: [
                  "updateTimelineShareData",
                  "updateAppMessageShareData",
                  "showAllNonBaseMenuItem",
                  "hideAllNonBaseMenuItem",
                  "showMenuItems",
                  "onMenuShareAppMessage",
                  "onMenuShareTimeline",
                ],
              });
              //通过ready接口处理成功验证
              wx.ready(function() {
                // 完全隐藏右上角的菜单
                wx.hideOptionMenu();

              });
            }
          });
      },
    },

    created: function() {
      //初始化
      this.initShow();
      //重新获取购物车信息
      this.getCartInfo();
      //微信分享
      this.wechatShare();
    },
  };
</script>

<style scoped>
  * {
    margin: 0;
    padding: 0;
  }

  .back-link {
    display: inline-block;
    color: black;
    text-decoration: none;
    border-radius: 5px;
    font-size: 16px;
  }

  .back-link span {
    font-size: 18px;
  }

  .back-link font {
    font-size: 13px;
  }


  .text-container {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    /* 限制在一个块元素显示的文本的行数 */
    -webkit-box-orient: vertical;
    /* 将块元素作为弹性伸缩盒子模型显示 */
    overflow: hidden;
    /* 隐藏超出的内容 */
    text-overflow: ellipsis;
    /* 用省略号(...)代替超出的文本 */
    font-size: 14px;
    font-weight: bold;
  }

  .page-body {
    max-width: 1000px;
    margin: 0 auto;
  }

  .empty-cart {
    text-align: center;
    font-size: 16px;
    color: #999;
    margin: 20px;
    margin-top: 200px;
  }

  .cart_content_div {
    display: flex;
    flex-direction: column;
  }

  .cart_content_top {
    border: 1px solid #eee;
    color: black;
    background-color: rgb(251, 251, 251);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 40px;
    display: flex;
    align-content: space-around;
    align-items: center;
  }

  .cart_content_top_l {
    width: 30%;
    margin-left: 10px;
    cursor: pointer;
  }

  .cart_content_top_r {
    width: 15%;
    text-align: center;
    margin-right: 10px;
  }

  .flex-spacer {
    flex: 1;
  }

  .spacer {
    height: 40px;
  }

  .good_list {
    /*background-color: rgb(251, 251, 251);*/
    background-color: #fff;
  }

  .good_list_row {
    display: flex;
    flex-direction: row;
    height: 119px;
    align-items: center;
    justify-content: center;
    margin: 5px 21px;
  }

  .radio-cell {
    width: 30px;
    text-align: center;
  }

  .image-cell {
    width: 100px;
  }

  .image-cell img {
    width: 80px;
    height: 80px;
    border: 1px solid #eee;
    border-radius: 5px;
  }

  .info-cell {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .text-container {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .price {
    color: #f85205;
  }

  .quantity input {
    width: 80px;
    text-align: center;
  }

  .cart_content_bottom {
    border: 1px solid #eee;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 118px;
    display: flex;
    align-content: space-around;
    align-items: center;
    background-color: rgb(251, 251, 251);
  }

  .cart_content_bottom_bottom {
    border: 1px solid #eee;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 60px;
    display: flex;
    align-content: space-around;
    align-items: center;
    background-color: rgb(251, 251, 251);
  }

  .cart_content_bottom_l {
    width: 30%;
    color: #a6a6a6;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .cart_content_bottom_r {
    width: 60%;
    text-align: center;
    margin-right: 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
  }

  .total-count {
    color: #e8c5af;
  }

  .generate-link {
    background-color: #ff5c01;
    color: #fff;
    border-radius: 10px;
    height: 30px;
    line-height: 30px;
    padding: 3px 10px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/views/fangancart.vue